import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RecordsTable from '../records_table/records_table';

export class Records extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }

  renderPageTitle() {
    const { totalCount, currentPage, pageSize } = this.props;

    const startIndex = ((currentPage - 1) * pageSize) + 1;
    let endingIndex = currentPage * pageSize;

    endingIndex = endingIndex > totalCount ? totalCount : endingIndex;

    return (
      <div className="h4 mt-5">
        Displaying {startIndex}-{endingIndex} of {totalCount} records in this file
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderPageTitle()}
        <RecordsTable />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  ...state.runRecords.meta,
});

export default connect(mapStateToProps)(Records);